import React from "react"
import PropTypes from "prop-types"
import { Button } from "gatsby-interface"

import Loading, { propTypes as loadingPropTypes } from "./Loading"

const propTypes = {
  ...loadingPropTypes,
  onClick: PropTypes.func,
}
delete propTypes.action

function LoadingFromExternalWindow({ onClick, ...delegated }) {
  return (
    <Loading
      {...delegated}
      action={
        <React.Fragment>
          <Button
            variant="GHOST"
            css={{
              fontSize: `inherit`,
              textDecoration: `underline`,
              padding: `0`,
            }}
            onClick={onClick}
            data-testid="loading-button"
          >
            Click here
          </Button>
          {` `}
          to open it again
        </React.Fragment>
      }
    />
  )
}

LoadingFromExternalWindow.propTypes = propTypes

export default LoadingFromExternalWindow
